<template>
  <div class="addres">
    <header-box />
    <div class="address">
      <div>
        <el-button @click="addAddress" style="margin: 5px" type="text"
          >添加地址
        </el-button>
      </div>
      <div class="addressHeader">
        <div>联系人</div>
        <div>电话</div>
        <div>地址</div>
        <div>是否为默认</div>
        <div>操作</div>
      </div>
      <div class="addList">
        <div
          class="addressList"
          :class="inde == index ? 'chooseIndex' : ''"
          v-for="(item, index) in addressArray"
          :key="index"
          @click="chooseIndex(index)"
        >
          <div>{{ item.Name }}</div>
          <div>{{ item.Phone }}</div>
          <div>
            {{ item.Province }}{{ item.City }}{{ item.Area }}{{ item.Detail }}
          </div>
          <div>
            <el-switch
              v-model="item.IsDefault"
              @change="IsDefaultChange(item)"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
          <div style="font-size: 0.8rem">
            <span style="color: #ffb000" @click="Modify(item)">修改</span>
            <el-popconfirm
              @confirm="confirm(item.Id)"
              title="您确定删除这条地址?"
            >
              <span style="color: #f00" slot="reference">删除</span>
            </el-popconfirm>
          </div>
        </div>
      </div>
    </div>
    <div class="btn">
      <button @click="prevClick">上一页</button>
      <button @click="nextClick">下一页</button>
    </div>

    <!-- 添加和修改地址 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      center
    >
      <div style="padding: 0.3rem">
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">收件人:</div>
          <div style="flex: 3">
            <el-input v-model.trim="addressItem.Name" />
          </div>
        </div>
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">联系电话:</div>
          <div style="flex: 3">
            <el-input v-model.trim="addressItem.Phone" />
          </div>
        </div>
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">添加地址:</div>
          <div
            v-if="AddressChange"
            style="flex: 3; display: flex; align-items: center"
          >
            <div
              @click="AddressChange = false"
              style="border: 1px solid #ddd; padding: 10px; border-radius: 5px"
            >
              {{ addressItem.Province }}-{{ addressItem.City }}-{{
                addressItem.Area
              }}
            </div>
            <span
              style="color: #f00; margin-left: 30px"
              @click="AddressChange = false"
              >编辑</span
            >
          </div>
          <div v-else style="flex: 3">
            <area-cascader
              separator
              type="all"
              :level="1"
              v-model.trim="selected"
              :data="pca"
            />
          </div>
        </div>
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">地址详情:</div>
          <div style="flex: 3">
            <el-input
              type="textarea"
              resize="none"
              :rows="3"
              placeholder="请输入内容"
              v-model.trim="addressItem.Detail"
            />
          </div>
        </div>
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">是否默认</div>
          <div style="flex: 3">
            <el-switch
              v-model.trim="addressItem.IsDefault"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddAndModify">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerBox from "../../components/box/headerbox.vue";
import { pca, pcaa } from "area-data";
import { address } from "../../api/http/address";
export default {
  components: {
    headerBox,
  },
  data() {
    return {
      dialogVisible: false, //地址对话框显示和隐藏
      pca, //地址
      isModify: false, //是否修改还是添加
      selected: [], //组件地址
      title: "添加地址", //添加地
      AddressChange: true, //是否添加和修改
      params: {
        page: 1,
        size: 20,
      },
      addressArray: [], //地址数组
      addressItem: "", //选中地址的
      inde: 0, //选中index
    };
  },
  watch: {
    selected(e) {
      for (let index = 0; index < e.length; index++) {
        for (const key in e[index]) {
          if (index == 0) {
            this.addressItem.Province = e[index][key];
          } else if (index == 1) {
            this.addressItem.City = e[index][key];
          } else {
            this.addressItem.Area = e[index][key];
          }
        }
      }
    },
  },
  created() {
     this.setAddressList();
  },
  methods: {
    // 上一页
    prevClick(){
      if(this.params.page>0){
        this.params.page--
        this.setAddressList();
      }else{
        this.params.page=1
        this.setAddressList();
        this.$message({
          message:"已经是第一页了",
          type:'success'
        })
      }
    },
    // 下一页
    nextClick() {
      if (this.addressArray.length == 0) {
        this.$message({
          message:"已经是最后一页了",
          type:"success"
        })
      } else {
        this.params.page++;
        this.setAddressList();
      }
    },
    // 选中
    chooseIndex(e) {
      this.inde = e;
    },
    // 设置默认
    IsDefaultChange(e) {
      address.addressAdd(e).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "修改默认成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "修改默认失败",
            type: "error",
          });
        }
        this.setAddressList();
      });
    },
    //删除地址是件
    confirm(e) {
      address.getAddressDel({ Id: e }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
        } else {
          this.$message({
            message: "删除失败！",
            type: "error",
          });
        }
        this.setAddressList();
      });
    },
    // 添加地址
    addAddress() {
      this.dialogVisible = true;
      this.AddressChange = false;
      this.isModify = false;
      this.addressItem = {
        Id: 0,
        Name: "",
        Phone: "",
        Province: "",
        City: "",
        Area: "",
        Detail: "",
        IsDefault: false,
      };
    },
    // 添加和修改
    AddAndModify() {
      console.log(this.addressItem);
      if (this.isModify == true) {
        address.addressAdd(this.addressItem).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "修改成功！！",
              type: "success",
            });
          } else {
            this.$message({
              message: "修改失败！！",
              type: "error",
            });
          }
        });
      } else {
        address.addressAdd(this.addressItem).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "添加成功！",
              type: "success",
            });
          } else {
            this.$message({
              message: "添加失败！",
              type: "error",
            });
          }
        });
      }
      this.dialogVisible = false;
      this.setAddressList();
    },
    // 关闭弹窗
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 修改显示按钮
    Modify(e) {
      this.title = "修改地址";
      this.addressItem = e;
      this.isModify = true;
      this.dialogVisible = true;
    },
    // 获取地址列表
    setAddressList() {
      address.addressList(this.params).then((res) => {
        this.addressArray = res.data.data.reverse();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.addList {
  height: 50vh;
  overflow-y: scroll;
}
.btn {
  display: flex;
  justify-content: center;
  button {
    margin: 5px;
  }
}
.chooseIndex {
  background-color: #9bf1c2 !important;
}
.box-flex {
  display: flex;
  align-items: center;
  margin-top: 0.2rem;

  .el-input {
    width: 10rem;
  }
}
.addressList:hover {
  margin: 8px;
  box-shadow: 5px 5px 5px #13ce66;
}
.addressList {
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 5px;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 5px 5px 5px #999;
  div {
    flex: 1;
    text-align: center;
  }
}
.address {
  width: 90%;
  margin: auto;
  margin-top: 1rem;
  border-radius: 0.3rem;
  border: 0.1rem solid #999;
  .addressHeader {
    display: flex;
    div {
      flex: 1;
      padding: 5px;
      font-size: 1rem;
      background: #eee;
      box-shadow: 5px 5px 5px #999;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/my/address.vue